import { Icon } from "PFComponents/icon";

import css from "./priority_badge.module.scss";

type PriorityBadgeProps = {
  level?: string;
};

export const PriorityBadge = ({ level }: PriorityBadgeProps) => {
  if (level === "high") {
    return <Icon name="chevron-up" color="paletteRed0" />;
  } else if (level === "low") {
    return <Icon name="chevron-down" color="palettePrimary2" />;
  } else if (!level) {
    return <div className={css.none}>--</div>;
  } else {
    return <div className={css.other} />;
  }
};
